module.exports = __webpack_public_path__ + "static/media/circle-status-paid.99c15389.svg";